<ng-container *transloco="let t; read: 'user'">
  <div id="selectRating" class="rounded-lg  modal-body">
    <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle ml-auto"></i>
    @if (ratingSheet.measureRatingLevel) {
      <div class="grid border-b pb-5">
        <!-- Measure code, name and description are server-supplied: localized by the API, not by Transloco. -->
        <p class="col-span-2 text-lg font-semibold">{{ratingSheet.measureRatingLevel.code}}:
        {{ratingSheet.measureRatingLevel.name}}</p>
        <div [innerHTML]="ratingSheet.measureRatingLevel.description"></div>
        <div class="col-span-1 flex justify-end">
          <drdp-btn color="cancel" class="mr-2" mat-button mat-dialog-close>{{ t('inputRating.common.cancel') }}</drdp-btn>
          <drdp-btn color="save" class="mr-2" (click)="saveRating()">{{ t('inputRating.common.save') }}</drdp-btn>
        </div>
      </div>
    }

    <div mat-dialog-content>
      <drdp-portfolio-evidence-management #evidenceManagement [measureId]="dialogData.id" [evidences]="measureEvidence"
        [ageGradeId]="dialogData.ageGradeInstrumentId" [ageGradeInstrumentCode]="dialogData.ageGradeInstrumentCode"
        [isDomain]="false" [isPortfolio]="false" [ratingSheet]="ratingSheet" [dialogData]="dialogData"
        (rating)="onSubmit($event)" [hasStructuredPrompt]="dialogData.isStructuredPrompt" [isPilot]="dialogData.isPilotEnrollment"
        [is2025Measure]="dialogData.is2025Enrollment!">
      </drdp-portfolio-evidence-management>
    </div>
  </div>
</ng-container>
